import React from 'react';
import LinkAndAnchor from '../LinkAndAnchor';
import getBreadcrumbs from '../Markets/getBreadcrumbs';

const Breadcrumbs = ({ marketName, marketId }) => (
  [
    ...getBreadcrumbs(),
    <LinkAndAnchor
      route="market"
      params={{ marketId }}
    >
      {marketName}
    </LinkAndAnchor>,
  ]
);

export default Breadcrumbs;
